import { Document, Page, View, Text, Image } from '@react-pdf/renderer';
import styles from '../../sections/@dashboard/invoice/details/InvoiceStyle';
import { accessVerify, capitalize, safeJSONParse, utcMoment, handleNumber } from '../../utils/common';
import { fCurrency } from '../../utils/formatNumber';
import PropTypes from 'prop-types';

StockTransferPDF.propTypes = {
    transfer: PropTypes.object.isRequired,
};

export default function StockTransferPDF({ key, transfer }) {

    const {
        transferId,
        transferDateTime,
        confirmedAt,
        transferNote,
        transferStatus,
        addedUserName,
        confirmedUserName,
        totalQtyTransferred,
        totalAmount,
        stockOrderId,

        // FROM details
        fromLocationName,
        fromContact,

        // TO details
        toLocationName,
        toContact,

        stockDetailsArray = [],
    } = transfer;

    console.log('transfer ', transfer);


    return (
        <Document>
            <Page size="A4" style={styles.page}>
                {/* Header */}
                <View style={[styles.gridContainer, styles.mb40]}>
                    <Image source="/logo/invoice_logo.png" style={{ height: 80 }} />

                    <View style={{ alignItems: 'flex-end' }}>
                        <Text style={styles.h1}>Stock Transfer Note</Text>
                        <Text style={styles.h3}>
                            {transferStatus === '0' ? 'Pending' : 'Completed'}
                        </Text>
                        <Text>Transfer ID: {transferId}</Text>
                    </View>
                </View>

                {/* From / To Information */}
                {<View style={[styles.gridContainer, styles.mb40]}>
                    <View style={styles.col6}>
                        {fromLocationName && <>
                            <Text style={styles.overline}>From</Text>
                            <Text style={styles.body1}>Location: {fromLocationName}</Text>
                            {fromContact && (
                                <Text style={styles.body1}>Contact: {fromContact}</Text>
                            )}</>}
                    </View>

                    <View style={styles.col6}>
                        {toLocationName && <>
                            <Text style={styles.overline}>To</Text>
                            <Text style={styles.body1}>Location: {toLocationName}</Text>
                            {toContact && (
                                <Text style={styles.body1}>Contact: {toContact}</Text>
                            )}</>}
                    </View>
                </View>}

                {/* Transfer Meta Information */}
                <View style={[styles.gridContainer, styles.mb40]}>
                    <View style={styles.col6}>
                        <Text style={styles.overline}>Transfer Details</Text>
                        <Text style={styles.body1}>Stock Order ID: {stockOrderId}</Text>

                        <Text style={styles.body1}>
                            Date: {utcMoment(transferDateTime).format('DD MMMM YYYY')}
                        </Text>
                        <Text style={styles.body1}>Total Qty: {totalQtyTransferred}</Text>
                    </View>

                    <View style={styles.col6}>
                        <Text style={styles.overline}>Additional Info</Text>
                        <Text style={styles.body1}>Added By: {addedUserName} (At {utcMoment(transferDateTime).format('YYYY-MM-DD HH:mm:ss')})</Text>
                        <Text style={styles.body1}>
                            Confirmed By:{' '}
                            {confirmedUserName
                                ? `${confirmedUserName}${confirmedAt
                                    ? ` (At ${utcMoment(confirmedAt).format('YYYY-MM-DD HH:mm:ss')})`
                                    : ''
                                }`
                                : '—'}
                        </Text>

                        {transferNote ? (
                            <Text style={styles.body1}>Note: {transferNote}</Text>
                        ) : (
                            <Text style={styles.body1}>Note: -</Text>
                        )}

                    </View>
                </View>

                {/* Stock Transfer Table Title */}
                <Text style={[styles.overline, styles.mb8]}>
                    Stock Transfer Details
                </Text>

                {/* Table */}
                <View style={styles.table}>
                    {/* Header */}
                    <View style={styles.tableHeader}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableCell_1}>
                                <Text style={styles.subtitle2}>#</Text>
                            </View>
                            <View style={styles.tableCell_2}>
                                <Text style={styles.subtitle2}>Item</Text>
                            </View>
                            <View style={styles.tableCell_3}>
                                <Text style={styles.subtitle2}>Qty</Text>
                            </View>
                            <View style={styles.tableCell_3}>
                                <Text style={styles.subtitle2}>Unit Cost</Text>
                            </View>
                            <View style={[styles.tableCell_3, styles.alignRight]}>
                                <Text style={styles.subtitle2}>Total</Text>
                            </View>
                        </View>
                    </View>

                    {/* Body */}
                    <View style={styles.tableBody}>
                        {stockDetailsArray.map((item, index) => {
                            const sd = item.stockDetails || {};
                            const barcodes = [sd.stockCode];

                            return (
                                <View style={styles.tableRow} key={index}>
                                    <View style={styles.tableCell_1}>
                                        <Text>{index + 1}</Text>
                                    </View>

                                    <View style={styles.tableCell_2}>
                                        <Text style={styles.subtitle2}>{item.foodName}</Text>
                                        {barcodes?.length > 0 && <Text>Entered Barcodes:</Text>}
                                        {barcodes?.length > 0 && <Text>{barcodes?.toString()?.replaceAll(',', ' , ')}</Text>}
                                    </View>

                                    {/* <View style={styles.tableCell_2}>
                                        <Text>{sd.stockCode}</Text>
                                    </View> */}

                                    <View style={styles.tableCell_3}>
                                        <Text>{item.movedQty}</Text>
                                    </View>

                                    <View style={styles.tableCell_3}>
                                        <Text>{fCurrency(item.costPerUnit)}</Text>
                                    </View>

                                    <View
                                        style={[styles.tableCell_3, styles.alignRight, { paddingRight: 6 }]}
                                    >
                                        <Text>{fCurrency(item.totalAmount)}</Text>
                                    </View>
                                </View>
                            );
                        })}

                        {/* Total Row */}
                        <View style={[styles.tableRow, styles.noBorder]}>
                            <View style={styles.tableCell_1} />
                            <View style={styles.tableCell_2} />
                            <View style={styles.tableCell_3} />
                            <View style={styles.tableCell_3}>
                                <Text style={styles.h4}>Total</Text>
                            </View>
                            <View style={[styles.tableCell_3, styles.alignRight]}>
                                <Text style={styles.h4}>{fCurrency(totalAmount)}</Text>
                            </View>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    );
}
